import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const Box = styled.div`
  padding: 0 20px 200px 20px;

  .main-banner {
    width: calc(100% + 40px);
    height: 500px;
    margin: 0 -20px;
  }

  .progress-bar,
  .main-banner-pc {
    display: none;
  }

  .box-quick {
    ${mixin.flex({ direction: 'column', align: 'flex-start' })};
    margin: 12px -20px 0 -20px;
    row-gap: 6px;
    overflow: auto hidden;
    overscroll-behavior: contain auto;

    &::-webkit-scrollbar {
      display: none;
    }

    .list {
      ${mixin.flex({ justify: 'flex-start', align: 'flex-start' })};
      padding: 0 16px;
      column-gap: 6px;

      .item {
        min-width: 100px;
        height: 42px;
        border-radius: 2px;

        &:nth-child(even) {
          min-width: 160px;
        }
      }

      & + .list .item {
        min-width: 160px;

        &:nth-child(even) {
          min-width: 100px;
        }
      }
    }
  }

  .cont-title {
    margin-top: 28px;
    width: 292px;
    height: 23px;
  }

  .box-prd {
    ${mixin.flex({ direction: 'column', align: 'flex-start' })};
    margin: 16px -20px 0 -20px;
    row-gap: 24px;
    overflow: auto hidden;
    overscroll-behavior: contain auto;

    &::-webkit-scrollbar {
      display: none;
    }

    .list {
      ${mixin.flex({ justify: 'flex-start', align: 'flex-start' })};
      padding: 0 20px;
      column-gap: 6px;

      .item {
        .thum {
          width: 136px;
          height: 181px;
          border-radius: 4px;
        }
        .text01 {
          margin-top: 8px;
          width: 120px;
          height: 20px;
          border-radius: 4px;
        }
        .text02 {
          margin-top: 4px;
          width: 80px;
          height: 20px;
          border-radius: 4px;
        }
      }
    }
  }

  @media ${({ theme }) => `${theme.media.smMax}, ${theme.media.md}`} {
    padding: ${mixin.pxToVw('0 20 200 20')};

    .main-banner {
      width: calc(100% + ${mixin.pxToVw('40')});
      height: ${mixin.pxToVw('500')};
      margin: ${mixin.pxToVw('0 -20')};
    }

    .box-quick {
      margin: ${mixin.pxToVw('12 -20 0 -20')};
      row-gap: ${mixin.pxToVw('6')};

      .list {
        padding: ${mixin.pxToVw('0 20')};
        column-gap: ${mixin.pxToVw('6')};

        .item {
          min-width: ${mixin.pxToVw('100')};
          height: ${mixin.pxToVw('42')};
          border-radius: ${mixin.pxToVw('2')};

          &:nth-child(even) {
            min-width: ${mixin.pxToVw('160')};
          }
        }

        & + .list .item {
          min-width: ${mixin.pxToVw('160')};

          &:nth-child(even) {
            min-width: ${mixin.pxToVw('100')};
          }
        }
      }
    }

    .cont-title {
      margin-top: ${mixin.pxToVw('28')};
      width: ${mixin.pxToVw('292')};
      height: ${mixin.pxToVw('23')};
    }

    .box-prd {
      margin: ${mixin.pxToVw('16 -20 0 -20')};
      row-gap: ${mixin.pxToVw('24')};

      .list {
        padding: ${mixin.pxToVw('0 16')};
        column-gap: ${mixin.pxToVw('6')};

        .item {
          .thum {
            width: ${mixin.pxToVw('136')};
            height: ${mixin.pxToVw('181')};
            border-radius: ${mixin.pxToVw('4')};
          }

          .text01 {
            margin-top: ${mixin.pxToVw('8')};
            width: ${mixin.pxToVw('120')};
            height: ${mixin.pxToVw('20')};
            border-radius: ${mixin.pxToVw('4')};
          }

          .text02 {
            margin-top: ${mixin.pxToVw('4')};
            width: ${mixin.pxToVw('80')};
            height: ${mixin.pxToVw('20')};
            border-radius: ${mixin.pxToVw('4')};
          }
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    position: relative;
    padding: 430px 0 0 0;

    .box-prd,
    .cont-title,
    .main-banner {
      display: none;
    }

    .main-banner-pc {
      ${mixin.flex({})};
      position: absolute;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      column-gap: 18px;
      width: 100%;
      overflow: hidden;

      .thum {
        width: 430px;
        height: 410px;
      }
    }

    .box-quick {
      ${mixin.flex({ direction: 'column' })};
      margin: 36px auto 0 auto;
      row-gap: 8px;

      .list {
        padding: 0;
        column-gap: 8px;

        .item {
          min-width: 100px;
          height: 48px;
          border-radius: 2px;

          &:nth-child(even) {
            min-width: 160px;
          }
        }

        & + .list .item {
          min-width: 160px;

          &:nth-child(even) {
            min-width: 100px;
          }
        }
      }
    }
  }
`;
